import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { UploaderComponent } from '../../../shared/uploader';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { NzModalService } from 'ng-zorro-antd';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import {
  BusinessCodeService,
  CustomerService,
  ProductsService,
  DistributorsService,
  MediasService,
} from 'src/app/services';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Router } from '@angular/router';
import {
  capitalizeFirstLetter,
  removeAllSpacingBetweenWords,
} from '../../../helpers';

declare var $: any;

@Component({
  selector: 'app-media-create',
  templateUrl: './media-create.component.html',
  styleUrls: ['./media-create.component.scss'],
})
export class MediaCreateComponent implements OnInit {
  list = [];
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private modalService: NzModalService,
    private codeService: BusinessCodeService,
    private notification: NzNotificationService,
    private customerService: CustomerService,
    private productsService: ProductsService,
    private distributorsService: DistributorsService,
    private mediasService: MediasService
  ) {
    // @ts-ignore
    const optionList$: Observable<string> = this.searchChange$
      .asObservable()
      .pipe(debounceTime(500));

    optionList$.pipe(takeUntil(this.unsubscribe$)).subscribe((value) => {
      if (this.loadGLN) {
        const queryGLN = {
          name: value.trim(),
          status: 1,
          page: 1,
          page_size: 50,
        };
        this.codeService
          .list(queryGLN)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res) => {
              res.data.items.map((item) => {
                const data = {
                  value: item.id,
                  label: item.name + '(' + item.glnCode + ')',
                };
                this.list_gln.push(data);
              });
              this.isLoading = false;
            },
            (error) => {
              this.isLoading = false;
              this.list_gln = [];
            }
          );
      }

      if (this.loadGroups) {
        const queryGroup = {
          keyword: value.trim(),
          page: 1,
          page_size: 50,
        };
        this.customerService
          .listGroup(queryGroup)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res) => {
              this.isLoading = false;
              this.groups = [];

              if (res.code === 1) {
                const ids = [];
                this.list  = res.data.items;
                // list.map((item) => {
                //   ids.push(item.id);
                // });
                // console.log('res.data', res.data)
                // if (ids.length === res.data.totalElement) {
                //   this.customerService
                //     .getTotalCustomerOfGroup({ listCustomerGroupId: ids })
                //     .pipe(takeUntil(this.unsubscribe$))
                //     .subscribe((response) => {
                //       if (res.code === 1) {
                //         const data = response.data;
                //         console.log(data)
                //         list.map((item) => {
                //           // tslint:disable-next-line:variable-name
                //           const new_data = data.find(
                //             (element) => element.id === item.id
                //           );
                //           item.number = new_data.number;
                //           this.groups.push(item);
                //         });
                //       }
                //     });
                // }
              }
            },
            (error) => {
              this.isLoading = false;
              this.groups = [];
            }
          );
      }

      if (this.showProduct || this.loadProduct) {
        const queryProduct = {
          product_name: value.trim(),
          management_status: 1,
          page: 1,
          page_size: 50,
        };
        this.productsService
          .getAll(queryProduct)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res) => {
              const data = res.data.items;
              if (data != null) {
                data.map((item) => {
                  const product = {
                    id: undefined,
                    name: undefined,
                  };
                  if (item.productName) {
                    product.id = item.productId;
                    product.name =
                      item.productName + ' ' + '(' + item.barcode + ')';
                  } else {
                    product.id = item.productId;
                    product.name = '(' + item.barcode + ')';
                  }
                  this.products.push(product);
                });
              }
              this.isLoading = false;
            },
            (error) => {
              this.isLoading = false;
              this.products = [];
            }
          );
      }

      // tslint:disable-next-line:triple-equals
      if (this.notifTargetType == 3) {
        const queryDistributors = {
          name: value.trim(),
          page: 1,
          page_size: 50,
        };
        this.distributorsService
          .list(queryDistributors)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res) => {
              this.isLoading = false;
              res.data.items.map((item) => {
                const data = {
                  value: item.id,
                  label: item.name,
                };
                this.distributors.push(data);
              });
            },
            (error) => {
              this.isLoading = false;
              this.distributors = [];
            }
          );
      }
    });
  }
  loadGLN = true;
  loadGroups = true;
  loadProduct = false;
  unsubscribe$ = new Subject<void>();
  form = this.fb.group({
    name: ['', [Validators.required]],
    send_types: ['', [Validators.required]],
    // radio_types: ["", [Validators.required]],
    gln: [''],
    groupCustomer: [''],
    numberOfMessage: ['', [Validators.required]],
    title: [''],
    content: ['', [Validators.required]],
    product: [''],
    notifTargetType: [''],
    notifTargetValue: [''],
  });
  // ===data ==== //
  name;
  selectGln;
  listOfSelectedValueGroup = [];
  totalMessage;
  images = [];
  title = '';
  content = '';
  notifTargetType;
  product;
  date;
  time;
  phone = '';
  inAppShowGln;
  announceNotification;
  valueNotifTarget = '';
  // ====end data==== //
  showProduct = false;
  showNotifTarget = false;
  checkOptions = [
    { label: 'Thông báo Notification', value: '2' },
    { label: 'Tin nhắn lnapp', value: '1' },
    // {label: 'SMS Brandname (Nâng cấp trong thời gian tới)', value: '3', disabled: true}
  ];
  isLoading = false;
  isUploading = false;
  searchChange$ = new BehaviorSubject('');
  // tslint:disable-next-line:variable-name
  list_gln = [];
  groups = [];
  sendAction = 'bookSend';
  radioValue = 'A';
  productName = '';
  products = [];
  distributors = [];
  totalNoti = 0;
  totalInapp = 0;
  totalQuota = 0;
  messTotal = '';
  validName = false;
  messName = '';
  validNotifTargetType = false;
  validnumberOfMessage = false;
  validTitle = false;
  messTitle = '';
  validContent = false;
  messContent = '';
  validDate = false;
  validTime = false;
  validPage = false;
  validNotifTargetValue = false;
  messTemplate = '';
  validTemplate = false;
  contentMessage: any;

  listUserQuota: any = [];
  strUserQuota: any = '';

  ngOnInit() {


    this.validator();
    const storage = localStorage.getItem('groupIds');
    if (storage) {
      this.listOfSelectedValueGroup = storage.split(',');
    }
    this.getUserQuota();
    this.notification.config({
      nzPlacement: 'bottomRight',
    });
  }

  getUserQuota() {
    this.mediasService
      .getUserQuota()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: any) => {
        if (res.code === 1 && res.data) {
          this.listUserQuota = res.data.map((gg: any) => {
            const value = gg.quota || 0;
            const label = gg.unit || 'notification';
            return value + ' ' + label;
          });
          this.strUserQuota = this.listUserQuota
            ? this.listUserQuota.join(', ')
            : '';

          const maxNotiObj = res.data.find((gg: any) => gg.serviceType === 'NOTI');
          if (maxNotiObj) {
            this.totalNoti = maxNotiObj.quota;
          }
          const maxInapp = res.data.find((gg: any) => gg.serviceType === 'MESSAGE');
          if (maxInapp) {
            this.totalInapp = maxInapp.quota;
          }
          const maxQuota = res.data.find((gg: any) => gg.serviceType === 'SMS');
          if (maxQuota) {
            this.totalQuota = maxQuota.quota;
          }
        }
      });
  }

  loadDataChild($event: any) {
    this.contentMessage = $event;
    this.validTemplate = false;
    this.messTemplate = '';
    console.log($event);
  }

  validator() {
    this.validName = false;
    this.validNotifTargetType = false;
    this.validnumberOfMessage = false;
    this.validTitle = false;
    this.validContent = false;
    this.validDate = false;
    this.validTime = false;
    this.validPage = false;
    this.validNotifTargetValue = false;
  }

  searchGLN(event) {
    this.loadGLN = true;
    this.loadGroups = false;
    this.list_gln = [];
    this.isLoading = true;
    this.searchChange$.next(event);
  }

  searchGroup(event) {
    this.loadGLN = false;
    this.loadGroups = true;
    this.groups = [];
    this.isLoading = true;
    this.searchChange$.next(event);
  }

  searchProduct(event) {
    this.products = [];
    this.loadGLN = false;
    this.loadGroups = false;
    this.isLoading = true;
    this.searchChange$.next(event);
  }

  searchDistributors(event) {
    this.loadGLN = false;
    this.loadGroups = false;
    this.distributors = [];
    this.isLoading = true;
    this.searchChange$.next(event);
  }
  async log(value: object[]) {
    // @ts-ignore
    // @ts-ignore
    this.inAppShowGln = value.filter(z => z.value === '1')[0].checked;
    // @ts-ignore
    this.announceNotification = value.filter(z => z.value === '2')[0].checked;
    this.form.controls.numberOfMessage.setValidators([Validators.required]);
    this.showProduct = false;
    const checked = [];
    if (value) {
       value.map((item) => {
        // @ts-ignore
        if (item.checked === true) {
          // @ts-ignore
          checked.push(item.value);
        }
        // @ts-ignore
        // tslint:disable-next-line:triple-equals
        if (item.value == 1 && item.checked == true) {
          this.showProduct = true;
          this.searchProduct('');
        }
        // @ts-ignore
        // tslint:disable-next-line:triple-equals
        if (item.value == 2 && item.checked == true) {
          this.showNotifTarget = true;
        }
      });
    } else {
      checked.push(3);
    }

    if (checked.includes('1') && !checked.includes('2')) {
      this.form.controls.numberOfMessage.setValidators([
        Validators.required,
        Validators.max(this.totalInapp),
      ]);
      this.messTotal =
        'Số tin nhắn Inapp gửi đi không được lớn hơn số lượng còn lại';
    }
    if (checked.includes('2') && !checked.includes('1')) {
      this.form.controls.numberOfMessage.setValidators([
        Validators.required,
        Validators.max(this.totalNoti),
      ]);
      this.messTotal =
        'Số tin nhắn Notification gửi đi không được lớn hơn số lượng còn lại';
    }
    if (checked.includes(3)) {
      this.form.controls.numberOfMessage.setValidators([
        Validators.required,
        Validators.max(this.totalQuota),
      ]);
      this.messTotal =
        'Số tin nhắn SMS gửi đi không được lớn hơn số lượng còn lại';
    }
    if (checked.includes('1') && checked.includes('2')) {
      // tslint:disable-next-line:max-line-length
      this.form.controls.numberOfMessage.setValidators([
        Validators.required,
        Validators.max(
          this.totalNoti < this.totalInapp ? this.totalNoti : this.totalInapp
        ),
      ]);
      this.messTotal = 'Số tin nhắn gửi đi không được lớn hơn số lượng còn lại';
    }

    this.form.controls.numberOfMessage.updateValueAndValidity();
    if (checked.length > 0) {
      this.validNotifTargetType = false;
    }
    let list$;
    checked.map((item) => {
      // tslint:disable-next-line:triple-equals
      if (item == 2) {
        list$ = item;
      }
    });
    if (!list$) {
      this.showNotifTarget = false;
      this.notifTargetType = undefined;
    }
  }

  notiChange(event) {
    this.validPage = false;
    this.valueNotifTarget = undefined;
    // tslint:disable-next-line:triple-equals
    if (event == 4) {
      this.loadProduct = true;
      this.searchProduct('');
    } else {
      this.loadProduct = false;
    }
    // tslint:disable-next-line:triple-equals
    if (event == 3) {
      this.searchDistributors('');
    }
  }

  inputChange(event) {
    this[event] = false;
  }

  setTag(event) {
    const message = this.form.controls.content.value;
    const value = '#' + event + '# ';
    const valueForm = message.trim().length > 0 ? message + ' ' + value : value;
    this.form.controls.content.setValue(valueForm);
  }

  contentChange(event) {
    $('.message').scrollTop($('.message')[0].scrollHeight);
  }

  create(value: string) {

    console.log(this.form);

    this.validName = false;
    if (this.name) {
      // tslint:disable-next-line:triple-equals
      if (this.name.trim().length == 0) {
        this.messName = 'Tên chiến dịch không hợp lệ';
        this.validName = true;
      } else {
        if (this.name.trim().length > 255) {
          this.messName = 'Tên chiến dịch không được quá 255 ký tự';
          this.validName = true;
          return;
        }
        this.form.get('name').setValue(this.name);
      }
    }
    this.validNotifTargetType = false;
    const checked = [];
    if (this.checkOptions) {
      this.checkOptions.map((item) => {
        // @ts-ignore
        if (item.checked === true) {
          checked.push(parseInt(item.value, 10));
        }
      });
    } else {
      checked.push(3);
    }

    // tslint:disable-next-line:triple-equals
    if (checked.length == 0) {
      this.validNotifTargetType = true;
    }
    if (this.totalMessage % 1) {
      this.validnumberOfMessage = true;
    }
    this.validTitle = false;
    if (this.title) {
      if (this.title.trim().length === 0) {
        this.messTitle = 'Tiêu đề không hợp lệ';
        this.validTitle = true;
      }
      if (this.title.trim().length > 255) {
        this.messTitle = 'Tiêu đề không được quá 255 ký tự';
        this.validTitle = true;
      }
    }
    this.validContent = false;
    if (this.content) {
      if (this.content.trim().length === 0) {
        this.messContent = 'Nội dung không hợp lệ';
        this.validContent = true;
      }
      if (this.content.trim().length > 255) {
        this.messContent = 'Nội dung không được quá 255 ký tự';
        this.validContent = true;
      }
    }
    let date: any;
    let time: any;
    if (this.sendAction === 'sendNow') {
      this.validDate = false;
      this.validTime = false;
    } else {
      date = this.date ? this.getDate(this.date, 1) : '';
      this.validDate = false;
      if (!date) {
        this.validDate = true;
      }
      time = this.time ? this.getDate(this.time, 2) : '';
      this.validTime = false;
      if (!time) {
        this.validTime = true;
      }
    }

    let type$;
    let typesInapp$;
    checked.map((item) => {
      if (item === 1) {
        typesInapp$ = item;
      }
      if (item === 2) {
        type$ = item;
      }
    });
    this.validPage = false;
    if (type$) {
      if (!this.notifTargetType) {
        this.validPage = true;
      }
    }
    this.validNotifTargetValue = false;
    if (this.valueNotifTarget) {
      if (this.valueNotifTarget.trim().length === 0) {
        this.validNotifTargetValue = true;
      }
    }
    // tslint:disable-next-line:forin
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }

    if (
      !this.contentMessage ||
      (this.contentMessage && !this.contentMessage.brandName)
    ) {
      this.messTemplate = 'Tin nhắn mẫu không để trống';
      this.validTemplate = true;
    }

    if (this.form.invalid) {
      return;
    }
    const sendAt$ = date + ' ' + time;

    const nowSend$ =
      this.getDate(new Date(), 1) + ' ' + this.getDate(new Date(), 2);

    let mess$ = this.content;
    if (mess$ && mess$.includes('#Tên khách hàng')) {
      mess$ = this.content.replace(/#Tên khách hàng#/g, '[CUSTOMER_NAME]');
    }
    if (mess$ && mess$.includes('#Điện thoại khách hàng')) {
      mess$ = mess$.replace(/#Điện thoại khách hàng#/g, '[CUSTOMER_PHONE]');
    }

    if (!mess$ && this.contentMessage) {
      mess$ = this.contentMessage.templateContent;
    }

    // tslint:disable-next-line:max-line-length

    if (this.radioValue === 'A') {
      if (
        this.validName ||
        this.validNotifTargetType ||
        this.validnumberOfMessage ||
        this.validTitle ||
        this.validContent ||
        this.validDate ||
        this.validTime ||
        this.validPage ||
        this.validNotifTargetValue
      ) {
        return;
      }
    }
    if (this.radioValue === 'B') {
      if (
        this.validName ||
        this.validnumberOfMessage ||
        this.validDate ||
        this.validTime ||
        this.validTemplate
      ) {
        return;
      }
    }

    const body = {
      name: this.name
        ? capitalizeFirstLetter(removeAllSpacingBetweenWords(this.name.trim()))
        : '',
      send_types: checked,
      customerGroupIds: this.listOfSelectedValueGroup,
      numberOfMessage: this.totalMessage ? this.totalMessage : 0,
      images: this.images.length > 0 ? [this.images[0].url] : [''],
      title: this.title,
      message: mess$,
      productAttachmentId: undefined,
      sendAt: this.sendAction === 'bookSend' ? sendAt$ : nowSend$,
      enterpriseId: this.selectGln,
      notifTarget: undefined,
      phone: undefined,
      campaignType: this.radioValue === 'A' ? 0 : 1,
      brandName:
        this.contentMessage && this.contentMessage.brandName
          ? this.contentMessage.brandName
          : '',
      templateType:
        this.contentMessage && this.contentMessage.templateType
          ? this.contentMessage.templateType
          : null,
    };
    // tslint:disable-next-line:triple-equals
    if (typesInapp$ != undefined && this.product) {
      body.productAttachmentId = this.product;
    }
    if (this.notifTargetType) {
      body.notifTarget = {
        // tslint:disable-next-line:radix
        type: this.notifTargetType,
        value: this.valueNotifTarget,
      };
    }
    if (value === 'test') {
      body.phone = this.phone.trim();
      this.mediasService
        .testCampaign(body)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res) => {
            // @ts-ignore
            if (res.code === 1) {
              this.notification.success(
                'Thành công',
                'Gửi test chiến dịch thành công'
              );
            } else {
              // @ts-ignore
              this.notification.error(
                'Gửi test chiến dịch thất bại',
                 res.message
              );
            }
          },
          (error) => {
            this.notification.error(
              'Gửi test chiến dịch thất bại',
              'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
            );
          }
        );
      return;
    }

    if (!this.isUploading) {
      const brandName = body.brandName;
      const campaignType = body.campaignType;
      const customerGroupId = body.customerGroupIds.map(z => z.id);
      const enterpriseId = body.enterpriseId;
      this.mediasService
        .create(body)
        .pipe()
        .subscribe(
          (res) => {
            if (res.code === 1) {

              this.notification.success(
                'Thành công',
                'Thêm mới chiến dịch thành công'
              );

              setTimeout(() => {
                this.router.navigate(['/business/media']);
              }, 1000);
            } else {

              this.notification.error(
                'Thêm mới chiến dịch thất bại',
                res.message
              );
            }
          },
          (error) => {

            this.notification.error(
              'Thêm mới chiến dịch thất bại',
              'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
            );
          }
        );
    }
    this.isUploading = true;
    localStorage.removeItem('groupIds');
  }
  cancel() {

  }
  openUploadDialog(field: string) {
    const fileType = 'jpg,jpeg,png,gif,bmp';

    const modal = this.modalService.create({
      nzTitle: `Upload ${field}`,
      nzContent: UploaderComponent,
      nzComponentParams: {
        fileExt: fileType,
        multiple: true,
      },
    });
    modal.afterOpen.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      modal.getContentComponent().change.subscribe((changeParam) => {
        if (changeParam.type === 'success') {
          const data = {
            name: changeParam.file.name,
            type: changeParam.file.type,
            url: changeParam.file.response.url,
          };
          this[field] = [];
          this[field].push(data);
        }
      });
      modal
        .getContentComponent()
        .done.pipe(takeUntil(this.unsubscribe$))
        .subscribe((changeParam) => {
          modal.close();
        });
    });
  }

  onRemoveFile(field: string, index: number) {
    this[field].splice(index, 1);
  }

  // tslint:disable-next-line:variable-name
  getDate(date, number) {
    const today = new Date(date);
    let dd: any = today.getDate();
    let mm: any = today.getMonth() + 1;
    const yyyy = today.getFullYear();
    const hh = today.getHours();
    const minute = today.getMinutes();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    if (number === 1) {
      return dd + '/' + mm + '/' + yyyy;
    }
    return hh + ':' + minute;
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    localStorage.removeItem('groupIds');
  }

  resetDateTime() {
    this.date = null;
    this.time = null;
  }

  // thanglv add form add new media
  resetForm() {
    this.checkOptions = [
      { label: 'Thông báo Notification', value: '2' },
      { label: 'Tin nhắn lnapp', value: '1' },
    ];
    this.sendAction = 'bookSend';
    this.selectGln = undefined;
    this.listOfSelectedValueGroup = [];
    this.title = '';
    this.content = '';
    this.product = '';
    this.notifTargetType = '';
    this.valueNotifTarget = '';
    this.date = null;
    this.time = null;
    this.phone = '';
    this.totalMessage = '';
    this.validDate = false;
    this.validTime = false;
    this.form.reset();
    if (this.radioValue === 'A') {
      this.form.get('send_types').setValidators([Validators.required]);
      if (!this.inAppShowGln) {
        this.form.get('title').setValidators([Validators.required]);
      }
      this.form.get('content').setValidators([Validators.required]);
      this.form.get('groupCustomer').clearValidators();
      this.form.updateValueAndValidity();
    }
    if (this.radioValue === 'B') {
      this.messTemplate = '';
      this.validTemplate = false;
      this.contentMessage = null;
      this.form.get('send_types').clearValidators();
      this.form.get('title').clearValidators();
      this.form.get('content').clearValidators();
      this.form.get('groupCustomer').setValidators([Validators.required]);
      this.form.updateValueAndValidity();
    }
    this.form.updateValueAndValidity();
    console.log(this.form);
  }
}

